import { CustomEditor } from 'components/text-editor/hooks/use-custom-editor';
import useQuerySearchParams from 'routes/surface/hooks/use-query-search-params';
import { useHistory } from 'react-router-dom';

type UseScrollSnippetIntoView = (editor: CustomEditor, form: any) => void;

export default function useScrollSnippetIntoView(): UseScrollSnippetIntoView {
  const history = useHistory();
  const searchParams = useQuerySearchParams();

  return function (editor: CustomEditor, form: any) {
    if (searchParams.get('snippet')) {
      const snippet = form.values.snippets.find(
        (snippet) => snippet.id === searchParams.get('snippet'),
      );

      const annotationNode = editor
        .getAnnotations()
        .find(
          (annotation) => annotation.annotationId === snippet?.annotationId,
        );

      if (annotationNode) {
        setTimeout(() => {
          editor.scrollNodeIntoView(annotationNode);
          searchParams.delete('snippet');

          history.replace({
            search: searchParams.toString(),
          });
        }, 2000);
      }
    }
  };
}
